import { forwardRef, PropsWithChildren } from "react";
import Checkbox from "../core/Checkbox";

const SearchResultCard = forwardRef<
  HTMLDivElement,
  PropsWithChildren & {
    isSelected?: boolean;
    className?: string;
    isChecked?: boolean;
    isBatchSelectionActive?: boolean;
    onCheckedChange?: (checked: boolean) => void;
  }
>(({ children, isBatchSelectionActive, className = "", isSelected = false, isChecked = false, onCheckedChange }, ref) => {
  return (
    <div
      ref={ref}
      className={`search-result-card break-inside-avoid w-full flex flex-col flex-wrap md:flex-row gap-0 lg:gap-4 border-b-[1px] border-[#ccc] min-h-[242px] ${
        isSelected ? "bg-slate-100" : ""
      } ${className} py-3`}
    >
      {isBatchSelectionActive && (
        <div className="self-start basis-full md:basis-0">
          <Checkbox
            checked={isChecked}
            onCheckedChange={onCheckedChange}
          />
        </div>
      )}
      {children}
    </div>
  );
});
export default SearchResultCard;
